import { BillingProfileCompareOptions } from "../BillingProfileCompareOptions";
import { ChargeCodeXref } from "../ChargeCodeXref";
import { CommodityXref } from "../CommodityXref";
import { DeductCodeInvoiceXref } from "../DeductCodeInvoiceXref";
import { EdiApiUsers } from "../EdiApiUsers";
import { EdiNotify } from "../EdiNotify";
import { EdiPartnerQualifiers } from "../EdiPartnerQualifiers";
import { HandlingRequirementXref } from "../HandlingRequirementXref";
import { InboundFuncAck } from "../InboundFuncAck";
import { LocationCustomerXref } from "../LocationCustomerXref";
import { PackageTypeXref } from "../PackageTypeXref";
import { TrailerTypeXref } from "../TrailerTypeXref";
import { Button, Checkbox, DataHeader, DataSource, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBillingProfile extends Layout {
    buttonAckFilenameCustomize: Button;
    buttonAckTransactionCustomize: Button;
    buttonCustomFilename: Button;
    buttonCustomizeTransControNo: Button;
    buttonCustomizeZip: Button;
    buttonFuncAckMasterBatch: Button;
    buttonFuncAckTemplate: Button;
    buttonMasterBatch: Button;
    buttonOpenClassic: Button;
    buttonSchedule: Button;
    buttonSetup: Button;
    checkboxAllowCorrections: Checkbox;
    checkboxAllowXferAfterSettlement: Checkbox;
    checkboxAlwaysUpdateStop: Checkbox;
    checkboxAutoCreateOrder: Checkbox;
    checkboxAutoRate: Checkbox;
    checkboxEnfBatchCont997: Checkbox;
    checkboxIndividualBatch: Checkbox;
    checkboxIntercompany: Checkbox;
    checkboxPrintBills: Checkbox;
    checkboxSendFuncAck: Checkbox;
    checkboxSkipManualOrders: Checkbox;
    checkboxUseFuncMasterBatch: Checkbox;
    checkboxUseMBatch: Checkbox;
    dataheaderBillingProfile: DataHeader;
    labelAudit: Label;
    labelAuditWarning: Label;
    labelDays: Label;
    labelFor: Label;
    labelFuncMasterBatch: Label;
    labelHours: Label;
    labelImagingDescription: Label;
    labelMinutes: Label;
    labelNextBatchNumber: Label;
    labelOutbound: Label;
    layoutBillingProfileCompareOptions: BillingProfileCompareOptions;
    layoutChargeCodeXref: ChargeCodeXref;
    layoutCommodityXref: CommodityXref;
    layoutCrossReference: LocationCustomerXref;
    layoutDeductCodeXref: DeductCodeInvoiceXref;
    layoutEdiApiUsers: EdiApiUsers;
    layoutEdiPartnerQualifiers: EdiPartnerQualifiers;
    layoutHandlingRequirementXref: HandlingRequirementXref;
    layoutInboundFuncAck: InboundFuncAck;
    layoutNotifications: EdiNotify;
    layoutPackageTypeXref: PackageTypeXref;
    layoutTrailerTypeXref: TrailerTypeXref;
    panel1: Panel;
    panel2: Panel;
    panel3: Panel;
    panelAudit: Panel;
    panelCrossReference: Panel;
    panelHeader: Panel;
    panelInboundFuncAck: Panel;
    panelInboundGeneral: Panel;
    panelNextBatchNumber: Panel;
    panelOutboundAck: Panel;
    panelOutboundGeneral: Panel;
    panelPartnerNotes: Panel;
    sourceChargeCodeEdi: DataSource;
    sourceDeductCodeEdi: DataSource;
    sourceEdiApiUser: DataSource;
    sourceEdiCarrier: DataSource;
    sourceEdiCommodity: DataSource;
    sourceEdiCrossRefHandlingRequirement: DataSource;
    sourceEdiCrossRefPackageTypeCode: DataSource;
    sourceEdiCrossRefTrailerType: DataSource;
    sourceEdiCustomer: DataSource;
    sourceEdiImagingConfig: DataSource;
    sourceEdiNotify: DataSource;
    sourceEdiPartnerCodeDetail: DataSource;
    sourceEdiRequiredFieldOutboundInvoice: DataSource;
    sourceEdiShipmatchCrit: DataSource;
    sourceEdibillingProfileDisplay: DataSource;
    sourceEdilocation: DataSource;
    switchZipImages: Switch;
    tabAck: Tab;
    tabApiUser: Tab;
    tabBillTo: Tab;
    tabCarriers: Tab;
    tabCompare: Tab;
    tabCrossReferences: Tab;
    tabDataValidation: Tab;
    tabGeneral: Tab;
    tabImaging: Tab;
    tabNotifications: Tab;
    tabPartnerQualifiers: Tab;
    tabShipmentMatching: Tab;
    tabTab9: Tab;
    tableCarriers: Table;
    tableEdiCustomer: Table;
    tableImaging: Table;
    tableRequiredField: Table;
    tableShipMatchCrit: Table;
    tabsetBillingProfile: Tabset;
    textboxAckXmitMethod: Textbox;
    textboxAltPartnerId: Textbox;
    textboxAuditCutoffDays: Textbox;
    textboxAuditIntervalHours: Textbox;
    textboxAuditIntervalMinutes: Textbox;
    textboxAutoAccept: Textbox;
    textboxDirection: Textbox;
    textboxEdiCommId: Textbox;
    textboxErrorOptions: Textbox;
    textboxFaThreshold: Textbox;
    textboxFilename: Textbox;
    textboxFuncAckFilename: Textbox;
    textboxFuncAckSt02Frmt: Textbox;
    textboxFuncAckTid: Textbox;
    textboxFuncAltpartnerId: Textbox;
    textboxFuncCommId: Textbox;
    textboxFuncNextBatch: Textbox;
    textboxFuncPartnerId: Textbox;
    textboxFuncVersion: Textbox;
    textboxNextBatch: Textbox;
    textboxNotes: Textbox;
    textboxPartnerId: Textbox;
    textboxPartnerName: Textbox;
    textboxProcessPriority: Textbox;
    textboxSendToCompany: Textbox;
    textboxSt02Format: Textbox;
    textboxTemplateId: Textbox;
    textboxTransactionSet: Textbox;
    textboxTransmitMethod: Textbox;
    textboxUpdaterecsHow: Textbox;
    textboxVersion: Textbox;
    textboxZipFilename: Textbox;
}
